import { render } from "./InstanceTypeEditDialog.vue?vue&type=template&id=1d31d948"
import script from "./InstanceTypeEditDialog.vue?vue&type=script&lang=js"
export * from "./InstanceTypeEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__